module.exports = __webpack_public_path__ + "static/classicoJackeFrontLogo-55ac5aa77eb17337d69d226ff5ca9eb7.jpg";